export default __webpack_public_path__ + "static/media/station.bff7565f.gif";